import { CREATE_CHAT_REQUEST } from "../types";

export const initForm = (init) => ({
  type: CREATE_CHAT_REQUEST,
  payload: init,
});
